import {
  Box,
  Button,
  Fab,
  Grid,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";

import { useDispatch } from "react-redux";
import { setPageSizeScreenWise } from "../../items_services/itemServicesFunction";
import AddItem from "../../items_services/AddItem";
import { setSnackbar } from "../../../app/store/reducer";
import ItemCard from "../../items_services/ItemCard";
import { getItems, getItemsXlsx } from "../../items_services/itemApi";
import ItemCarRd from "./ListItemCard";
import TableReport from "./table";

export default function ListOfItemSerivces() {
  const [items, setItmes] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, total: 1 });
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [editedItem, setEditedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const isLargeScreen = useMediaQuery("(min-width: 1280px)"); // 'lg' breakpoint
  const isMediumScreen = useMediaQuery(
    "(min-width: 960px) and (max-width: 1279px)"
  ); // 'md' breakpoint

  // };
  useEffect(() => {
    let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);
    getItems({ pagination, pageSize }).then((res) => {
      setItmes(res.data.data);
      setPagination({
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setTotalItems(res.data.totalRecords);
    });
  }, []);
  useEffect(() => {
    let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);

    getItems({ pagination, search, pageSize }).then((res) => {
      setItmes(res.data.data);
      setPagination({
        ...pagination,
        page: search ? 1 : pagination.page,
        total: res.data.totalPages,
      });
      setTotalItems(res.data.totalRecords);
    });
  }, [pagination.page, search]);
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const downloadXLSXFile = async () => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );
      let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);

      const response = await getItemsXlsx({ pagination, pageSize })

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };
  return (
    <Grid
      container
      sx={{
        p: "17px 30px",
        display: "flex",
        background: "#ede9ff",
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          background:
            "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
          padding: "10px",
          mt: "10px",
          borderRadius: "5px",
          color: "#01008B", // optional text color
          textAlign: "left",
          marginBottom: "10px",
          fontFamily: "'Montserrat', sans-serif",
          fontSize: "20px",
          fontWeight: 500,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontSize: { xs: "12px", sm: "13px", md: "18px" },
          }}
        >
          List Of Items/ Services
        </Typography>
      </Grid>
      <Grid
        item
        container
        xs={12}
        spacing={2}
        sx={{ paddingTop: "15px", paddingRight: "10px" }}
      >
        <Grid item xs={12} sm={9} md={10}>
          <TextField
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            sx={{
              width: "100%",
              background: "#fff",
              borderRadius: 1,
              cursor: "pointer",
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
              border: "none",
              "& fieldset": { border: "none" },
            }}
            size="small"
            id="outlined-basic-search"
            label="Search Items..."
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {search ? (
                    <CloseIcon
                      onClick={() => {
                        setSearch("");
                      }}
                      sx={{ cursor: "pointer" }}
                    />
                  ) : (
                    <SearchIcon />
                  )}
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item md={2} sm={3} xs={12}>
          <Button
            variant="contained"
            fullWidth
            onClick={() => downloadXLSXFile()}
            sx={{ height: "40px", backgroundColor: "#14008B", padding: "0px" }}
            endIcon={<DownloadIcon />}
          >
            Download
          </Button>
        </Grid>

        {/* <Grid
          item
          xs={2}
        >
          <Button
            variant="contained"
            fullWidth
            onClick={() => {
              setOpen(true);
            }}
            sx={{ height: '40px', backgroundColor: '#14008B', padding: "0px" }}
            endIcon={<AddIcon />}
          >
            Add Item
          </Button>
        </Grid> */}
      </Grid>

      {/* <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          padding: "0 20px"
        }}
      >
        <Fab
          onClick={() => {
            setOpen(true);
          }}
          sx={{
            textTransform: "capitalize",
            width: {
              xs: "100%",
              sm: "auto",
            },
            // p: "10px",
            whiteSpace: "nowrap",
            zIndex: "0",
          }}
          size="small"
          color="primary"
          variant="extended"
          aria-label="add"
        >
          Add Item
          <AddIcon />
        </Fab>
      </Grid> */}
      {/* <Grid item xs={4}>
        <Typography color="primary">
          <strong>Total Services And Products : &nbsp;</strong>
          <span
            style={{ color: "#bb4a9b", fontSize: "18px", fontWeight: "500" }}
          >
            {totalItems}
          </span>
        </Typography>
      </Grid> */}
      {/* <Grid
        container
        xs={12}
        sx={{ padding: "0 20px" }}> */}
      <Grid
        item
        xs={"auto"}
        sx={{
          padding: "10px 16px",
          margin: "14px 8px 0px 0",
          fontWeight: "500",
          backgroundColor: "#CCCCFF",
          borderRadius: "8px",
        }}
      >
        <Typography
          component="p"
          sx={{
            display: "flex",
            alignItems: "center",
            marginLeft: "5px",
            color: "#00008B",
          }}
        >
          <Typography
            component="span"
            sx={{
              fontWeight: 500,
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            Total Services And Products:&nbsp;&nbsp;&nbsp;
          </Typography>
          <Typography
            component="span"
            sx={{
              fontWeight: "bold",
              marginLeft: "5px",
              fontSize: { xs: "12px", sm: "13px", md: "15px" },
            }}
          >
            {totalItems}
          </Typography>
        </Typography>
      </Grid>

      {/* </Grid> */}
      <Grid
        container
        sx={{
          mt: 2,
          width: "100%",
          // padding: "0 20px"
        }}
      >
        {/* {items.map((item) => {
          // return null
          return (
            <Grid item lg={4} sm={12} xs={12} md={12}>
              <Paper>
                <ItemCarRd
                  setEditedItem={() => {
                    //   setEditedItem(item);
                    //   setOpen(true);
                  }}
                  item={item}
                />
              </Paper>
            </Grid>
          );
        })} */}
        <TableReport data={items} />
      </Grid>
      {/* <Grid container sx={{ pt: "10px" }}>
        <Grid
          item
          xs={12}
          sx={{
            // bgcolor: "red",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Pagination
            count={pagination.total}
            page={pagination.page}
            onChange={handleChange}
            sx={{ marginBottom: { xs: 2 } }}
          />
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid> */}
      <AddItem
        open={open}
        item={editedItem}
        setEditedItem={setEditedItem}
        setOpen={setOpen}
        onSave={() => {
          let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);
          getItems({ pagination, pageSize }).then((res) => {
            setItmes(res.data.data);
            setPagination({
              page: res.data.pageNumber,
              total: res.data.totalPages,
            });
            setTotalItems(res.data.totalRecords);
          });
          setOpen(false);
          dispatch();
          // setSnackbar({
          //   open: true,
          //   message: "Item saved successfully",
          // })
        }}
      />
    </Grid>
  );
}
